import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "entityTypeInput",
    "companyContainer",
    "companyInput",
    "individualContainer",
    "vatRegisteredInput",
    "vatNumberContainer",
    "vatNumberInput"
  ]

  #vatNumberRequired = false

  connect() {
    this.#vatNumberRequired = this.hasVatNumberInputTarget && this.vatNumberInputTarget.required
    this.toggleEntitySpecificFields()
  }

  toggleEntitySpecificFields() {
    const entityType = this.entityTypeInputTarget.value
    const isCompanySelected = entityType === "company"

    this.#toggleContainers(this.companyContainerTargets, isCompanySelected)
    this.#toggleInputs(this.companyInputTargets, isCompanySelected)
    // The individual containers hold labels only: the fields they label are shared with a company.
    this.#toggleContainers(this.individualContainerTargets, !isCompanySelected)

    this.toggleVatNumber()
  }

  toggleVatNumber() {
    const isCompanySelected = this.entityTypeInputTarget.value === "company"
    const isVatRegistered = this.vatRegisteredInputTarget.value === "true"
    const showVatNumber = isCompanySelected && isVatRegistered

    this.vatNumberContainerTargets.forEach(container => {
      container.classList.toggle("d-none", !showVatNumber)
    })

    this.vatNumberInputTargets.forEach(input => {
      this.#updateVatNumberInput(input, showVatNumber)
    })
  }

  // When hidden, the field is cleared but kept enabled so the empty value is submitted and any
  // persisted VAT number is removed. A disabled field would be omitted, leaving the old value behind.
  #updateVatNumberInput(input, showVatNumber) {
    if (showVatNumber) {
      input.disabled = false
      input.required = this.#vatNumberRequired
    } else {
      input.value = ""
      input.disabled = false
      input.required = false
    }
  }

  #toggleContainers(containers, isVisible) {
    containers.forEach(container => {
      container.classList.toggle("d-none", !isVisible)
    })
  }

  #toggleInputs(inputs, isVisible) {
    inputs.forEach(input => {
      input.disabled = !isVisible
    })
  }
}
